import { EducationBlockProps } from "../components/EducationBlock/EducationBlock";


export const EducationData: EducationBlockProps[] = [
    {
        title: "Coding Dojo",
        descriptions: [
            "Immersive 80 hours per week for 14 weeks training program focused on full-stack development in Python, Java, and MERN"
        ],
        location: "Remote",
        duration: "April 2021 - August 2021",
        image: "/images/dojo.png"
    },
    {
        title: "Skyline College",
        descriptions: [
            "A.A. Psychology 2020",
            "A.A. Social & Behavioral Sciences 2020"
        ],
        location: "San Bruno, CA",
        duration: "August 2016 - August 2021",
        image: "/images/skyline.png"
    }
]